const sources = ['User', 'Subscription'];

export { sources };
